import styled from "styled-components";

interface SwitchProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  label: string;
  name?: string;
  className?: string;
}

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const LabelText = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  margin-right: 5px;
`;

const Rail = styled.div<{ active?: boolean }>`
  width: 46px;
  height: 28px;
  transition: background-color 0.25s linear;
  background: ${({ active }) => (active ? "#195DEE" : "#f3f4f8")};
  border-radius: 21px;
  position: relative;
  padding: 3px;
`;

const Toggle = styled.div<{ active?: boolean }>`
  background-color: white;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  translate: transform 0.25s linear;
  transform: ${({ active }) => (active ? "translateX(18px)" : "translateX(0)")};
`;

// CONTROLLED INPUT FIELD
const Switch = ({
  onChange,
  checked = false,
  name,
  label,
  className,
}: SwitchProps) => {
  return (
    <div className={className}>
      <Label>
        <input
          name={name}
          type="checkbox"
          style={{
            visibility: `hidden`,
          }}
          onChange={onChange}
          checked={checked}
        />
        <LabelText>{label}</LabelText>
        <Rail active={checked}>
          <Toggle active={checked} />
        </Rail>
      </Label>
    </div>
  );
};

export default Switch;
